import { render, staticRenderFns } from "./CatalogWishlistButton.vue?vue&type=template&id=ea2691c6"
import script from "./CatalogWishlistButton.vue?vue&type=script&lang=ts"
export * from "./CatalogWishlistButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports